/* ==================================================
   VIVANDI HAIR QUIZ
   PART 3A
================================================== */

const VHQ = {

  currentStep: 0,

  answers: {},

  selectedCheckboxes: [],

  questions: [

    {
      id: 'shop_for',
      title: 'Who are you shopping for?',
      type: 'radio',
      options: [
        'Myself',
        'My Husband',
        'My Wife',
        'My Child',
        'Someone Else'
      ]
    },

    {
      id: 'gender',
      title: 'What is your gender?',
      type: 'radio',
      options: [
        'Female',
        'Male'
      ]
    },

    {
      id: 'age',
      title: 'What is your age?',
      type: 'radio',
      options: [
        'Under 18',
        '18–29',
        '30–39',
        '40–49',
        '50–59',
        '60+'
      ]
    },

    {
      id: 'concern',
      title: 'What best describes your biggest concern?',
      type: 'radio',
      options: [
        'Increased hair shedding',
        'Hair is becoming thinner',
        'Receding hairline',
        'Bald spots',
        'Weak or brittle hair',
        'Dry scalp',
        'Oily scalp',
        'Loss of hair volume'
      ]
    },

    {
      id: 'duration',
      title: 'How long have you noticed this problem?',
      type: 'radio',
      options: [
        'Less than 3 months',
        '3–6 months',
        '6–12 months',
        '1–2 years',
        'More than 2 years'
      ]
    },

    {
      id: 'thinning_area',
      title: 'Where is your hair thinning the most?',
      type: 'conditional'
    },

    {
      id: 'factors',
      title: 'Which of these may apply to you?',
      type: 'checkbox',
      options: [
        'Stress',
        'Menopause',
        'Postpartum',
        'Weight loss',
        'Diet changes',
        'Family history',
        'Thyroid issues',
        'None of these'
      ]
    },

    {
      id: 'previous_treatment',
      title: 'Have you used hair loss products before?',
      type: 'radio',
      options: [
        'Never',
        'Minoxidil',
        'Supplements',
        'Laser therapy',
        'Prescription treatment',
        'Several products'
      ]
    },

    {
      id: 'routine',
      title: 'What type of routine do you prefer?',
      type: 'radio',
      options: [
        'Very simple (1 minute)',
        'Moderate (5 minutes)',
        'Complete hair care routine'
      ]
    },

    {
      id: 'commitment',
      title: 'How committed are you?',
      type: 'radio',
      options: [
        'I want the fastest comprehensive approach',
        'I am willing to be consistent for several months',
        'I want to start small'
      ]
    },

    {
      id: 'budget',
      title: 'What is your budget?',
      type: 'radio',
      options: [
        'Under $100',
        '$100–200',
        '$200–350',
        'Over $350'
      ]
    },

    {
      id: 'specialist_products',
      title: 'Are you interested in professional-strength products recommended by hair specialists?',
      type: 'radio',
      options: [
        'Yes',
        'Maybe',
        'No Preference'
      ]
    }

  ],

  init() {

    this.renderQuestion();

  },

  getCurrentQuestion() {

    return this.questions[this.currentStep];

  },

  updateProgress() {

    const total = this.questions.length;

    const percent = ((this.currentStep) / total) * 100;

    const bar = document.querySelector('.vhq-progress-bar');

    if (bar) {

      bar.style.width = percent + '%';

    }

  },

  renderQuestion() {

    this.updateProgress();

    const container = document.getElementById('vhq-content');

    const question = this.getCurrentQuestion();

    if (!question) {

      this.renderLeadForm();
      return;

    }

    if (question.type === 'conditional') {

      this.renderConditionalQuestion();
      return;

    }

    if (question.type === 'checkbox') {

      this.renderCheckboxQuestion(question);
      return;

    }

    container.innerHTML = `

      <div class="vhq-card">

        <div class="vhq-question-title">
          ${question.title}
        </div>

        <div class="vhq-options">

          ${question.options.map(option => `

            <button
              class="vhq-option"
              onclick="VHQ.selectOption('${question.id}', '${option.replace(/'/g, "\\'")}')"
            >
              ${option}
            </button>

          `).join('')}

        </div>

      </div>

    `;

  },

  renderConditionalQuestion() {

    const container = document.getElementById('vhq-content');

    const gender = this.answers.gender || '';

    let options = [];

    if (gender === 'Female') {

      options = [
        'Overall thinning',
        'Part line widening',
        'Crown',
        'Temples',
        'Entire scalp'
      ];

    } else {

      options = [
        'Hairline',
        'Crown',
        'Top of scalp',
        'Diffuse thinning'
      ];

    }

    container.innerHTML = `

      <div class="vhq-card">

        <div class="vhq-question-title">
          Where is your hair thinning the most?
        </div>

        <div class="vhq-options">

          ${options.map(option => `

            <button
              class="vhq-option"
              onclick="VHQ.selectOption('thinning_area','${option}')"
            >
              ${option}
            </button>

          `).join('')}

        </div>

      </div>

    `;

  },

  renderCheckboxQuestion(question) {

    this.selectedCheckboxes = [];

    const container = document.getElementById('vhq-content');

    container.innerHTML = `

      <div class="vhq-card">

        <div class="vhq-question-title">
          ${question.title}
        </div>

        <p style="margin-bottom:20px;color:#666;">
          Select all that apply.
        </p>

        <div class="vhq-checkbox-grid">

          ${question.options.map(option => `

            <div
              class="vhq-checkbox"
              onclick="VHQ.toggleCheckbox(this,'${option}')"
            >
              ${option}
            </div>

          `).join('')}

        </div>

        <div class="vhq-nav">

          <button
            class="vhq-btn vhq-btn-primary"
            onclick="VHQ.saveCheckboxAnswer()"
          >
            Continue
          </button>

        </div>

      </div>

    `;

  },

  toggleCheckbox(element, value) {

    element.classList.toggle('active');

    if (this.selectedCheckboxes.includes(value)) {

      this.selectedCheckboxes =
        this.selectedCheckboxes.filter(v => v !== value);

    } else {

      this.selectedCheckboxes.push(value);

    }

  },

  saveCheckboxAnswer() {

    this.answers.factors = this.selectedCheckboxes;

    this.nextStep();

  },

  selectOption(questionId, value) {

    this.answers[questionId] = value;

    this.nextStep();

  },

  nextStep() {

    this.currentStep++;

    this.renderQuestion();

  },

  previousStep() {

    if (this.currentStep > 0) {

      this.currentStep--;

      this.renderQuestion();

    }

  },
  /* ==========================================
     LEAD CAPTURE FORM
  ========================================== */

  renderLeadForm() {

    const container = document.getElementById('vhq-content');

    const progressBar =
      document.querySelector('.vhq-progress-bar');

    if (progressBar) {
      progressBar.style.width = '100%';
    }

    container.innerHTML = `

      <div class="vhq-card">

        <div class="vhq-question-title">
          Where should we send your personalized hair plan?
        </div>

        <form
          id="vhq-lead-form"
          class="vhq-form"
        >

          <input
            type="text"
            id="vhq-name"
            class="vhq-input"
            placeholder="Your Name"
            required
          >

          <input
            type="email"
            id="vhq-email"
            class="vhq-input"
            placeholder="Email Address"
            required
          >

          <input
            type="tel"
            id="vhq-phone"
            class="vhq-input"
            placeholder="Phone Number (Optional)"
          >

          <label class="vhq-checkbox-consent">

            <input
              type="checkbox"
              id="vhq-consent"
              checked
            >

            <span>
              Email me educational tips and
              exclusive offers.
            </span>

          </label>

          <button
            type="submit"
            class="vhq-btn vhq-btn-primary"
          >
            Get My Personalized Plan
          </button>

        </form>

      </div>

    `;

    const form =
      document.getElementById('vhq-lead-form');

    form.addEventListener(
      'submit',
      this.handleLeadSubmit.bind(this)
    );

  },

  handleLeadSubmit(event) {

    event.preventDefault();

    const name =
      document.getElementById('vhq-name').value.trim();

    const email =
      document.getElementById('vhq-email').value.trim();

    const phone =
      document.getElementById('vhq-phone').value.trim();

    if (!name) {

      alert('Please enter your name');
      return;

    }

    if (!this.validateEmail(email)) {

      alert('Please enter a valid email');
      return;

    }

    this.answers.lead = {
      name,
      email,
      phone
    };

    this.storeLead();

    this.renderResults();

  },

  validateEmail(email) {

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      .test(email);

  },

  /* ==========================================
     LEAD STORAGE
  ========================================== */

  storeLead() {

    try {

      const existing =
        JSON.parse(
          localStorage.getItem('vivandiQuizLeads')
        ) || [];

      existing.push({

        date: new Date().toISOString(),

        answers: this.answers

      });

      localStorage.setItem(
        'vivandiQuizLeads',
        JSON.stringify(existing)
      );

    } catch (e) {

      console.log(
        'Lead storage unavailable'
      );

    }

  },

  /* ==========================================
     PROGRAM RECOMMENDATION ENGINE
  ========================================== */

  getRecommendation() {

    const gender =
      this.answers.gender || '';

    const concern =
      this.answers.concern || '';

    const commitment =
      this.answers.commitment || '';

    const budget =
      this.answers.budget || '';

    if (
      gender === 'Female' &&
      (
        concern === 'Hair is becoming thinner' ||
        concern === 'Loss of hair volume' ||
        concern === 'Increased hair shedding'
      )
    ) {

      return {

        title:
          "Women's Hair Restoration Program",

        intro:
          "Based on your answers, we recommend a comprehensive program combining nutritional support, professional recovery treatments and targeted hair care to help support stronger, healthier-looking hair.",

        products: [

          window.vivandiProducts.viviscal,

          window.vivandiProducts.recovery,

          window.vivandiProducts.shampoo

        ],

        profile: [

          'Hair thinning concerns',

          'Looking for healthy hair support',

          'Interested in a complete routine'

        ],

        routine: {

          morning: [

            'Viviscal PRO',

            'Tricomax Shampoo'

          ],

          evening: [

            'Professional Hair Recovery Kit'

          ],

          scheduled: [

            'Follow product instructions consistently',

            'Take monthly progress photos'

          ]

        }

      };

    }

    if (
      gender === 'Male' &&
      concern === 'Receding hairline'
    ) {

      return {

        title:
          'Advanced Hair Recovery Program',

        intro:
          'Your answers suggest a targeted restoration program focused on supporting hair density, strengthening existing hair and promoting a consistent long-term routine.',

        products: [

          window.vivandiProducts.viviscal,

          window.vivandiProducts.recovery,

          window.vivandiProducts.ampoules

        ],

        profile: [

          'Hairline recession concerns',

          'Long-term consistency recommended',

          'Comprehensive support program'

        ],

        routine: {

          morning: [

            'Viviscal PRO'

          ],

          evening: [

            'Professional Hair Recovery Kit'

          ],

          scheduled: [

            'Pharma Hermetic Ampoules',

            'Track progress monthly'

          ]

        }

      };

    }

    return {

      title:
        'Personalized Hair Restoration Program',

      intro:
        'Based on your assessment, we recommend a balanced program designed to support overall hair health and help you maintain a consistent routine.',

      products: [

        window.vivandiProducts.viviscal,

        window.vivandiProducts.recovery,

        window.vivandiProducts.shampoo

      ],

      profile: [

        'General hair wellness support',

        'Consistency is important',

        'Complete care routine'

      ],

      routine: {

        morning: [

          'Viviscal PRO',

          'Tricomax Shampoo'
        ],

        evening: [

          'Professional Hair Recovery Kit'
        ],

        scheduled: [

          'Monthly progress photos'
        ]

      }

    };

  },

  /* ==========================================
     RESULTS PAGE
  ========================================== */

  renderResults() {

    const recommendation =
      this.getRecommendation();

    const container =
      document.getElementById('vhq-content');

    container.innerHTML = `

      <div class="vhq-results">

        <h2>
          ${recommendation.title}
        </h2>

        <div class="vhq-profile">

          ${recommendation.profile
            .map(item => `
              <div class="vhq-profile-item">
                ✓ ${item}
              </div>
            `).join('')}

        </div>

        <div class="vhq-program-intro">

          ${recommendation.intro}

        </div>

        <div
          id="vhq-products"
          class="vhq-products"
        >

          ${recommendation.products
            .map(product => `

              <div class="vhq-product">

                <img
                  src="${product.image}"
                  class="vhq-product-image"
                  alt="${product.title}"
                >

                <div class="vhq-product-content">

                  <div class="vhq-product-title">
                    ${product.title}
                  </div>

                  <div class="vhq-product-price">
                    ${product.price}
                  </div>

                  <a
                    href="${product.url}"
                    class="vhq-product-link"
                  >
                    View Product
                  </a>

                </div>

              </div>

            `).join('')}

        </div>

        <div class="vhq-routine">

          <h3>Your Suggested Routine</h3>

          <strong>Morning</strong>

          <ul>

            ${recommendation.routine.morning
              .map(item =>
                `<li>${item}</li>`
              ).join('')}

          </ul>

          <br>

          <strong>Evening</strong>

          <ul>

            ${recommendation.routine.evening
              .map(item =>
                `<li>${item}</li>`
              ).join('')}

          </ul>

          <br>

          <strong>Scheduled</strong>

          <ul>

            ${recommendation.routine.scheduled
              .map(item =>
                `<li>${item}</li>`
              ).join('')}

          </ul>

        </div>

            <div style="margin-top:30px;">

          <button
            class="vhq-add-program"
            onclick="VHQ.addProgramToCart()"
          >
            Add Complete Program To Cart
          </button>

        </div>

      </div>

    `;

    this.currentRecommendation = recommendation;

  },

  /* ==========================================
     ADD COMPLETE PROGRAM TO CART
  ========================================== */

  async addProgramToCart() {

    if (
      !this.currentRecommendation ||
      !this.currentRecommendation.products
    ) {
      return;
    }

    const button =
      document.querySelector('.vhq-add-program');

    if (button) {

      button.disabled = true;

      button.innerHTML =
        'Adding Program To Cart...';

    }

    try {

      const items =
        this.currentRecommendation.products.map(
          product => ({
            id: product.variant,
            quantity: 1
          })
        );

      const response =
        await fetch('/cart/add.js', {

          method: 'POST',

          headers: {
            'Content-Type': 'application/json'
          },

          body: JSON.stringify({
            items: items
          })

        });

      if (!response.ok) {

        throw new Error(
          'Unable to add products'
        );

      }

      this.showSuccessMessage();

    } catch (error) {

      console.error(error);

      alert(
        'Something went wrong while adding products to your cart.'
      );

      if (button) {

        button.disabled = false;

        button.innerHTML =
          'Add Complete Program To Cart';

      }

    }

  },

  /* ==========================================
     SUCCESS MESSAGE
  ========================================== */

  showSuccessMessage() {

    const container =
      document.getElementById('vhq-content');

    container.innerHTML = `

      <div class="vhq-success">

        <h3>
          Your Personalized Program Has Been Added To Cart
        </h3>

        <p style="margin-bottom:25px;">

          All recommended products have been added.

        </p>

        <a
          href="/cart"
          class="vhq-btn vhq-btn-primary"
          style="
            display:inline-block;
            text-decoration:none;
          "
        >
          View Cart
        </a>

      </div>

    `;

  }

};

/* ==========================================
   INITIALIZE QUIZ
========================================== */

document.addEventListener(
  'DOMContentLoaded',
  function () {

    VHQ.init();

  }
);